import React from 'react';
import { Alert } from 'reactstrap';
import { shouldShowDevWarning } from '../../helper/devWarning.helper.js';

const ALERT =
    <Alert
            color="danger"
            className="mb-0 text-center"
            style={{
                borderRadius: 0,
                fontSize: '14px',
                fontWeight: 'bold',
                padding: '8px'
            }}
        >
            ⚠️ WARNING: PRODUCTION ENVIRONMENT ⚠️
    </Alert>

const DevWarningBanner = ({ user }) => {
    if (!shouldShowDevWarning(user)) {
        return null;
    }

    return ALERT;
};

export default DevWarningBanner;